export {
  addFavoriteApi,
  getFavoritesApi,
  getProductsByIdsApi,
  removeFavoriteApi,
  syncFavoritesApi,
} from './favoritesApi';
export type { FavoritesListResponse, ProductsByIdsRequest } from './favoritesApi';
